import { render, staticRenderFns } from "./ApprovalModule.vue?vue&type=template&id=9353a3aa&scoped=true&"
import script from "./ApprovalModule.vue?vue&type=script&lang=js&"
export * from "./ApprovalModule.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalModule.vue?vue&type=style&index=0&id=9353a3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9353a3aa",
  null
  
)

export default component.exports